if (!customElements.get('fa-announcement')) {
  customElements.define('fa-announcement', class extends HTMLElement {
    connectedCallback() {
      this.update = () => document.documentElement.style.setProperty('--fa-announcement-height', this.dataset.pinned === 'true' ? `${this.closest('.shopify-section').offsetHeight}px` : '0px');
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.closest('.shopify-section'));
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.documentElement.style.setProperty('--fa-announcement-height', '0px');
    }
  });
}
